import axios from "axios";

export const reSyncWallet = async (walletIds: string[]) => {
  await axios.post("/wallets/re-sync", { ids: walletIds });
};
